import { faWindowMaximize } from '@fortawesome/pro-regular-svg-icons/faWindowMaximize';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Group } from './group';
import { FooterAlignProperty } from '../../properties-panel/widget-properties/footer-align/footer-align';
import { HeightProperty } from '../../properties-panel/widget-properties/height-input/height-input';
import { WidthProperty } from '../../properties-panel/widget-properties/width-input/width-input';
import { WIDGET_TYPE } from '../widget-type';

import type { FooterWidget, FooterWidgetDefinition, WidgetProps, WidgetConfig, WidgetProperties } from '../../config';

const footerDefinition: FooterWidgetDefinition = {
  type: WIDGET_TYPE.footer,
  ui: {
    label: 'Footer',
    pickerElement: <FontAwesomeIcon icon={faWindowMaximize} transform={{ rotate: 180 }} />,
    supportedNestedTypes: [WIDGET_TYPE.text, WIDGET_TYPE.line, WIDGET_TYPE.barcode],
    isBuiltInTemplate: true,
  },
  initialConfiguration: {
    height: 60,
    width: 144,
    alignMode: 'afterLastRow',
  },
};

const footerProperties: WidgetProperties<FooterWidget> = [WidthProperty, HeightProperty, FooterAlignProperty];

const Footer = ({ widget, components }: WidgetProps<FooterWidget>) => {
  return <Group components={components} parentWidget={widget} supportedNestedTypes={footerDefinition.ui.supportedNestedTypes} />;
};

export const FooterWidgetConfig: WidgetConfig<FooterWidget> = {
  Component: Footer,
  definition: footerDefinition,
  properties: footerProperties,
};
